<template>
  <div>
    <template v-for="item in links">
      <template v-if="item.isExpendable && !item.hidden">
        <div>
          <b-dropdown size="lg" variant="text" toggle-class="d-md-none nav-link" class="d-inline-block">
            <template #button-content>{{ item.title }}
            </template>
            <b-dropdown-item
                v-for="underItem in underlinks[item.underlinksIndex]"
                :key="underItem.route"
                :to="underItem.route"
            >
              {{ underItem.title }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template v-else-if="!item.hidden">
        <b-nav-item class="d-md-none nav-link" :to="item.route">
          {{ item.title }}
        </b-nav-item>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "NavBarMenu",
  props: {
    links: {type: Array},
    underlinks: {type: Array},
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/menus/NavBarMenu.vue